import { Chip } from '@/components/ui/Chip/Chip'
import { Stack } from '@/components/ui/Stack/Stack'
import { Text } from '@/components/ui/Text/Text'
import type { FeedState } from '@/hooks/state/useFeed'
import { spacing } from '@/themes/spacing.stylex'
import type { IconProps } from '@tabler/icons-react'
import { IconBlur } from '@tabler/icons-react'
import { memo } from 'react'
import { css } from 'react-strict-dom'

const iconProps: IconProps = {
  size: 18,
  strokeWidth: '1.5',
}

type Props = {
  feed: FeedState
}

export const FeedSettingsSafety = memo(function FeedSettingsSafety(props: Props) {
  const { feed } = props
  return (
    <Stack horizontal={false} gap={0.5}>
      <Text variant='label' size='lg' sx={styles.label}>
        Safety
      </Text>
      <Stack gap={0.5} wrap>
        <Chip
          selected={feed.blured}
          variant='filter'
          icon={<IconBlur {...iconProps} />}
          selectedIcon={null}
          label='Blur Images'
          onClick={() => feed.setBlured((prev) => !prev)}
        />
      </Stack>
    </Stack>
  )
})

const styles = css.create({
  label: {
    marginLeft: spacing.margin1,
  },
})
